export default __webpack_public_path__ + "static/media/Handguards of the Eternal Blaze.36ab4afe.jpg";